import { render, staticRenderFns } from "./AutoCampaignShow.vue?vue&type=template&id=28c05e48&"
import script from "./AutoCampaignShow.vue?vue&type=script&lang=js&"
export * from "./AutoCampaignShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports